import { type CustomFieldDefinitionAttributes } from './generated/CustomFieldDefinitionAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';

interface CustomFieldDefinition extends CustomFieldDefinitionAttributes {}

@model
class CustomFieldDefinition extends ApplicationModel {
  // Start auto-generated
  static typename: 'CustomFieldDefinition' = 'CustomFieldDefinition';
  get typename(): 'CustomFieldDefinition' {
    return 'CustomFieldDefinition';
  }

  static internalTypename: 'CustomFieldDefinition' = 'CustomFieldDefinition';
  get internalTypename(): 'CustomFieldDefinition' {
    return 'CustomFieldDefinition';
  }

  static fields = {
    id: attr({ readable: true }),
    key: attr({ readable: true }),
    name: attr({ readable: true }),
    type: attr({ readable: true }),
    permissions: attr.belongsTo({
      readable: true,
      typename: 'ResourcePermissions',
    }),
    customFieldOptions: attr.hasMany({ readable: true }),
  };
  // End auto-generated
}

export default CustomFieldDefinition;
